export function calculatePercentage(part: number, whole: number) {
  if (whole === 0) {
    return 0;
  }
  return (part / whole) * 100;
}
